<!-- Header -->
<div class="min-[991px]:hidden px-[16px] my-[24px]">
  <app-auto-registration-top-bar
    logoSrc="assets/img/glameraTradeMarkLogo2.png"
    [logoWidth]="132"
    [mobileLogoWidth]="110"
    languageColor="#000"
    [darkMode]="true"
    (watchVideo)="onOpenVideo()"
  ></app-auto-registration-top-bar>
</div>

<!-- Title & Back Button -->
<div class="px-[16px] min-[991px]:px-[48px] mt-[10px] min-[991px]:mt-[62px] pb-[14px]">
  <!-- Step 1: Enter phone -->
  <ng-container *ngIf="step === 'enter_phone'">
    <h1 class="mb-[8px] min-[991px]:mb-[16px] text-[14px] min-[991px]:text-[32px] font-[500] text-[#000]">
      {{ "RESET_PASSWORD" | translate }}
    </h1>
    <p class="mb-[19px] min-[991px]:mb-[40px] text-[12px] min-[991px]:text-[20px] font-[400] text-[#4D5762]">
      {{ "ENTER_PHONE_NUMBER_DESC" | translate }}
    </p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="flex flex-col mb-[2px] min-[991px]:mb-[8px]">
        <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
          {{ "AUTH.PHONE_NUMBER" | translate }}
        </mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            [placeholder]="'ENTER_PHONE_NUMBER' | translate"
            formControlName="MobileNumber"
            [maxLength]="12"
            appNumberOnly
          />
          <mat-error>
            <app-error-form
              [name]="'PHONE_NUMBER'"
              [control]="form.controls['MobileNumber']"
              [maxLength]="12"
              [minLength]="4"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="mb-[24px] min-[991px]:mb-[48px]">
        <app-verify-identity
          [showPhoneNumber]="true"
          [inlineMode]="true"
          [inlineUser]="mobileNumber"
          [inlineVerifyType]="selectedVerifyType"
          [canChangeVerifyType]="true"
          (backToVerification)="onVerifyTypeChange($event)"
        ></app-verify-identity>
      </div>

      <div class="min-[991px]:w-[446px] mx-auto">
        <button
          type="submit"
          class="generic-submit-btn"
          [disabled]="form.invalid || loading || !selectedVerifyType"
        >
          {{ "RESET_PASSWORD" | translate }}
          <span class="btn-spinner-icon" *ngIf="loading"></span>
        </button>
      </div>
    </form>
  </ng-container>

  <!-- Step 2: Enter OTP -->
  <ng-container *ngIf="step === 'enter_otp'">
    <div class="mb-[8px] min-[991px]:mb-[16px] flex items-center justify-start">
      <h1 class="text-[14px] min-[991px]:text-[32px] font-[500] text-[#000]">
        {{ "Verification_Code" | translate }}
      </h1>

      <!-- Back Button -->
      <div class="w-[32px] h-[32px] rounded-[50px] bg-[#F9F9FA] ms-[12px] min-[991px]:ms-[26px] cursor-pointer flex items-center justify-center hover:brightness-95 transition"
        [matTooltip]="'BACK_TO_PHONE_NUMBER' | translate"
        matTooltipPosition="above"
        (click)="backToPhoneNumberStep()">
        <svg
          [ngClass]="dir == 'en' ? 'rotate-180' : ''"
          width="12"
          height="10"
          viewBox="0 0 8 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.90625 0.28125L0.28125 2.90622M0.28125 2.90622L2.90625 5.53122M0.28125 2.90622H7.03125"
            stroke="#2F384C"
            stroke-width="0.5625"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <p class="mb-[19px] min-[991px]:mb-[40px] text-[12px] min-[991px]:text-[20px] font-[400] text-[#4D5762]">
      {{ otpStepMessageKey | translate: { number: submittedMobileNumber } }}
    </p>

    <div class="min-[991px]:w-max min-[991px]:mx-auto pb-[14px]">
      <ng-otp-input
        dir="ltr"
        #otpInputRef
        class="custom-otp-inputs"
        [config]="otpInputConfig"
        (onInputChange)="onOtpInputChange($event)"
      ></ng-otp-input>
    </div>
    <div class="my-[24px] flex items-center justify-center" *ngIf="confirmLoading">
      <span class="btn-spinner-icon m-0"></span>
    </div>
  </ng-container>

  <!-- Step 3: Enter new password -->
  <ng-container *ngIf="step === 'enter_new_password'">
    <div class="mb-[8px] min-[991px]:mb-[16px] flex items-center justify-start">
        <h1 class="text-[14px] min-[991px]:text-[32px] font-[500] text-[#000]">
            {{ "UPDATE_YOUR_PASSWORD" | translate }}
        </h1>
        <!-- Back Button -->
        <div class="w-[32px] h-[32px] rounded-[50px] bg-[#F9F9FA] ms-[12px] min-[991px]:ms-[26px] cursor-pointer flex items-center justify-center hover:brightness-95 transition"
            [matTooltip]="'BACK_TO_OTP' | translate"
            matTooltipPosition="above"
            (click)="backToOTPStep()">
            <svg
            [ngClass]="dir == 'en' ? 'rotate-180' : ''"
            width="12"
            height="10"
            viewBox="0 0 8 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
                d="M2.90625 0.28125L0.28125 2.90622M0.28125 2.90622L2.90625 5.53122M0.28125 2.90622H7.03125"
                stroke="#2F384C"
                stroke-width="0.5625"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            </svg>
        </div>
    </div>
    
    <p class="mb-[19px] min-[991px]:mb-[40px] text-[12px] min-[991px]:text-[20px] font-[400] text-[#4D5762]">
      {{ "NEW_PASSWORD_SHOULD_BE_DIFFERENT" | translate }}
    </p>

    <form [formGroup]="form">
      <!-- newPassword Field -->
      <div class="flex flex-col mb-[24px]">
        <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
          {{ "PASSWORD" | translate }}
        </mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="newPassword"
            [placeholder]="'ENTER_PASSWORD' | translate"
            [maxLength]="20"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
            [attr.aria-pressed]="hidePassword"
            type="button"
          >
            @if (hidePassword) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                />
                <path
                  d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                />
              </svg>
            }
          </button>
          <mat-error>
            <app-error-form
              [name]="'PASSWORD'"
              [control]="form.get('newPassword')"
              [minLength]="6"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </div>

      <button
        type="button"
        (click)="onSubmitNewPassword()"
        class="generic-submit-btn"
        [disabled]="form.get('newPassword')?.invalid || loading"
      >
        {{ "Confirm" | translate }}
        <span class="btn-spinner-icon" *ngIf="loading"></span>
      </button>
    </form>
  </ng-container>
</div>
